import React from 'react';
import Icon from '../../../components/AppIcon';

const BookingStatusPanel = ({ bookings }) => {
  const getBookingTypeIcon = (type) => {
    switch (type) {
      case 'flight': return 'Plane';
      case 'hotel': return 'Building';
      case 'ground_transportation': return 'Car';
      default: return 'Package';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed': return 'success';
      case 'pending': return 'warning';
      case 'cancelled': return 'error';
      case 'completed': return 'secondary';
      default: return 'muted';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="glass-container rounded-xl border border-border/50">
      <div className="p-6 border-b border-border/50">
        <h3 className="text-lg font-semibold text-foreground">Booking Status</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Real-time booking confirmations and updates
        </p>
      </div>
      <div className="p-6">
        <div className="space-y-4">
          {bookings?.map((booking) => (
            <div
              key={booking?.id}
              className="flex items-center justify-between p-4 rounded-lg border border-border/50 hover:bg-white/5 transition-colors duration-200"
            >
              <div className="flex items-center space-x-4">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center border text-${getStatusColor(booking?.status)} bg-${getStatusColor(booking?.status)}/10 border-${getStatusColor(booking?.status)}/20`}>
                  <Icon name={getBookingTypeIcon(booking?.bookingType)} size={20} />
                </div>
                <div>
                  <div className="flex items-center space-x-2 mb-1">
                    <h4 className="font-medium text-foreground">{booking?.vendor}</h4>
                    <span className={`px-2 py-1 rounded text-xs font-medium text-${getStatusColor(booking?.status)} bg-${getStatusColor(booking?.status)}/10`}>
                      {booking?.status?.toUpperCase()}
                    </span>
                  </div>
                  <div className="flex items-center space-x-3 text-sm text-muted-foreground">
                    <span>{booking?.requestNumber}</span>
                    <span>•</span>
                    <span>{booking?.reference}</span>
                    <span>•</span>
                    <span>{formatDate(booking?.travelDate)}</span>
                  </div>
                </div>
              </div>

              <div className="text-right">
                <p className="text-lg font-semibold text-foreground">
                  ${booking?.cost?.toLocaleString()}
                </p>
                <p className="text-xs text-muted-foreground capitalize">
                  {booking?.bookingType?.replace('_', ' ')}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BookingStatusPanel;